/* ------------------------------------------------
** fixed-screen:屏幕滚动时悬停在原位置
** 父元素需设置position;
** fixed-top需设置left:0;width:100%;
--------------------------------------------------*/
$(function () {
    $(".fixed-screen").each(function () {
        var that = $(this);
        //检查父元素是否设置position属性
        $(window).scroll(function () {
            var height = that.outerHeight();
            var pheight = that.parents().outerHeight();
            var ptop = that.parents().offset().top; //父元素距顶部的高度

            console.log(`父元素高度：`, pheight, `元素高度：`, height);
            var scrolltop = $(window).scrollTop();
            console.log(`父元素高度：`, pheight, `元素高度：`, height, `距顶部距离：`, scrolltop, `父元素距顶部距离`, ptop);
            if (scrolltop >= ptop) {
                if (scrolltop < ptop + pheight - height) {
                    //console.log(`我执行了`)
                    d = scrolltop - ptop;
                } else {
                    d = pheight - height;
                }
                that.css({ position: 'absolute', top: d });
            }
        })
    })
});